import tipoPicRouter from '@/router/cadastros/apoio-vendas/tipo-pic.router';
import tipoTabelaRouter from '@/router/cadastros/apoio-vendas/tipo-tabela.router';
import picRegraRouter from '@/router/cadastros/apoio-vendas/pic-regra.router';
import alcadaRouter from '@/router/cadastros/apoio-vendas/alcada.router';
import representanteRouter from '@/router/cadastros/apoio-vendas/representante.router';
import represCondPagtoRouter from '@/router/cadastros/apoio-vendas/repres-cond-pagto.router';
import TipoComunicadoRouter from '@/router/cadastros/comunicado/tipo-comunicado.router';
import ComunicadoRouter from '@/router/cadastros/comunicado/comunicado.router';
import GrupoComercialRouter from '@/router/cadastros/cliente/grupo-comercial.router';
import ClienteRouter from '@/router/cadastros/cliente/cliente.router';
import ClienteTipoPedidoRouter from '@/router/cadastros/cliente/cliente-tipo-pedido.router';
import cadastrosUnidadeNegocioRouter from './informacoes-organizacionais/cadastros-unidade-negocio.router';
import transportadoraRouter from './informacoes-organizacionais/transportadora.router';
import estabelecimentoRouter from './informacoes-organizacionais/estabelecimento.router';
import empresaRouter from './informacoes-organizacionais/empresa.router';
import canalVendaRouter from './informacoes-organizacionais/cadastros-canal-venda.router';
import templateImagemRouter from './cadastros-template-imagem.router';
import imagemHomeRouter from './cadastros-imagem-home.router';

export default [
  ...imagemHomeRouter,
  ...templateImagemRouter,
  ...canalVendaRouter,
  ...empresaRouter,
  ...estabelecimentoRouter,
  ...transportadoraRouter,
  ...tipoPicRouter,
  ...tipoTabelaRouter,
  ...picRegraRouter,
  ...alcadaRouter,
  ...representanteRouter,
  ...represCondPagtoRouter,
  ...TipoComunicadoRouter,
  ...ComunicadoRouter,
  ...GrupoComercialRouter,
  ...ClienteRouter,
  ...cadastrosUnidadeNegocioRouter,
  ...ClienteTipoPedidoRouter,
];
